import * as React from 'react'
import { LOCALE } from '@foxrenderfarm/internals'
import { CurrentLocaleItem, LocaleItem, LocaleItemsWrapper, LocaleMenuWrapper } from './atoms'
import { useRef, useState, useEffect } from 'react'
import { LocaleClass } from '../../utils'
import { useClickAway } from '../../hooks'
import { DownArrowIcon } from './svg'

const LOCALES_MAP = new Map([
  [LOCALE.EN, 'English'],
  [LOCALE.ES, 'España'],
  [LOCALE.PT, 'Português'],
  [LOCALE.DE, 'Deutsch'],
  [LOCALE.TR, 'Türkiye'],
  [LOCALE.JP, '日本語'],
  [LOCALE.IT, 'Italiano'],
  [LOCALE.FR, 'Français'],
  [LOCALE.RU, 'Россия'],
  [LOCALE.KR, '한국어'],
])

interface Props {
  currentLocale: LOCALE
  displayLanguages?: LOCALE[]
}
interface TLocaleList {
  value: string
  key: string
  link: string
}

export const LocaleMenu = ({ currentLocale, displayLanguages }: Props) => {
  const localeMenuWrapRef = useRef<HTMLDivElement | null>(null)
  const [showLocaleMenu, setShowLocaleMenu] = useState(false)
  const [localeList, setLocaleList] = useState<TLocaleList[]>([])

  useClickAway(localeMenuWrapRef, () => {
    showLocaleMenu && setShowLocaleMenu(false)
  })

  useEffect(() => {
    const localeList: TLocaleList[] = [...LOCALES_MAP.keys()].map((item) => ({
      value: LOCALES_MAP.get(item) as string,
      key: item,
      link:
        item === LOCALE.EN
          ? `${LocaleClass.getPathWithoutLocale()}`
          : `/${item}${LocaleClass.getPathWithoutLocale()}`,
    }))
    setLocaleList(localeList)
  }, [])

  return (
    <LocaleMenuWrapper ref={localeMenuWrapRef} $show={showLocaleMenu}>
      <CurrentLocaleItem $show={showLocaleMenu} onClick={() => setShowLocaleMenu(!showLocaleMenu)}>
        <span>{LOCALES_MAP.get(currentLocale)}</span>
        <DownArrowIcon />
      </CurrentLocaleItem>
      <LocaleItemsWrapper $show={showLocaleMenu}>
        {displayLanguages
          ? displayLanguages
          : localeList.map((item) => (
              <LocaleItem key={item.key} href={item.link} $isActive={currentLocale === item.key}>
                {item.value}
              </LocaleItem>
            ))}
      </LocaleItemsWrapper>
    </LocaleMenuWrapper>
  )
}
